
import { CompanyModule } from "@/models/company-module";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import {ExtraUsersMetaData} from "@/models/module-extra-users-meta-data";
import { CompanyService } from "@/services/company-service";
import { Company } from "@/models/company";

export default FormLike.extend({
	data(){
		return {
			count: 0
		};
	},
	props: {
		value: {
			type: Object as ()=>CompanyModule,
			required: true
		},
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.count = ExtraUsersMetaData.create(this.value.metaData).getExtraUsers();
			}
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async submit(){
			if (!this.isValid) return;
			ExtraUsersMetaData.create(this.value.metaData).setExtraUsers(this.count);
			await CompanyService.updateModuleOfCompany(this.company, this.value.id, this.value.metaData);
			this.$emit("saved", this.value);
			this.$emit("close");
		}
	}
});
